/* eslint-disable */
export default {
  onSearching: 'A carregar…',
  noContacts: 'Não foram encontrados registos.',
} as const;

// @key: @#@"onSearching"@#@ @source: @#@"Loading..."@#@
// @key: @#@"noContacts"@#@ @source: @#@"No records found."@#@
